import { useState, useEffect } from 'react';
import { navItems, siteInfo } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-[72px] flex items-center justify-between">
        <a
          href="#hero"
          className="flex items-center gap-2 no-underline shrink-0"
        >
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-lg"></i>
          </div>
          <span className="text-xl font-heading font-bold text-foreground-950 whitespace-nowrap">
            {siteInfo.name}
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors duration-200 rounded-md whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#carousel"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line"></i>
            <span>开始观看</span>
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors duration-200"
              onClick={() => setMobileOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#carousel"
            className="mt-2 inline-flex items-center justify-center gap-1.5 px-5 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors duration-200"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-play-circle-line"></i>
            <span>开始观看</span>
          </a>
        </div>
      )}
    </header>
  );
}